import { useSyncExternalStore } from 'react';

/**
 * 남은 메시지(리모컨 공지/질문) 상태를 상단 네비 버튼과 공유하는 가벼운 전역 스토어.
 * useRemoteReceiver 가 publish, RemoteBacklogNavButton 이 구독. (탭 메모리 전용)
 */
export type RemoteBacklogNavState = {
  /** 수신 측(useRemoteReceiver)이 마운트돼 있음 */
  active: boolean;
  /** 미확인 개수 */
  count: number;
  /** 전체(확인함 포함) 개수 */
  total: number;
  collapsed: boolean;
  /** 상단 네비 버튼이 마운트돼 있는 개수 — 0이면 대체 칩 표시 */
  navButtons: number;
};

let state: RemoteBacklogNavState = { active: false, count: 0, total: 0, collapsed: false, navButtons: 0 };
let expandHandler: (() => void) | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());
const setState = (patch: Partial<RemoteBacklogNavState>) => {
  const next = { ...state, ...patch };
  if (
    next.active === state.active &&
    next.count === state.count &&
    next.total === state.total &&
    next.collapsed === state.collapsed &&
    next.navButtons === state.navButtons
  )
    return;
  state = next;
  emit();
};

export const remoteBacklogStore = {
  get: () => state,
  subscribe: (l: () => void) => {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
  publish: (active: boolean, count: number, total: number, collapsed: boolean) =>
    setState({ active, count, total, collapsed }),
  setExpandHandler: (fn: (() => void) | null) => {
    expandHandler = fn;
  },
  expand: () => expandHandler?.(),
  registerNavButton: () => {
    setState({ navButtons: state.navButtons + 1 });
    return () => setState({ navButtons: Math.max(0, state.navButtons - 1) });
  },
};

export function useRemoteBacklogNavState(): RemoteBacklogNavState {
  return useSyncExternalStore(remoteBacklogStore.subscribe, remoteBacklogStore.get, remoteBacklogStore.get);
}
